<markant-platform-modal-bridge>
  <markant-dialog class="modal" [open]="true" (close)="closeDialog.emit()">
    <section class="modal-header">
      <h2>
        {{
          'upgrade.pfa.wizard.section-' + currentStepIndex() + '.title'
            | transloco
        }}
      </h2>
      <h5>
        {{
          'upgrade.pfa.wizard.section-' + currentStepIndex() + '.subtitle'
            | transloco: { orgName: organization().name }
        }}
      </h5>
    </section>

    <section class="stepper-header">
      <markant-stepper-horizontal
        class="upgrade-stepper"
        [numbered]="true"
        [clickable]="false"
        [skippable]="false"
        [currentStepIndex]="currentStepIndex()"
      >
        <markant-stepper-item
          [description]="'upgrade.pfa.wizard.section-0.description' | transloco"
        ></markant-stepper-item>
        <markant-stepper-item
          [description]="'upgrade.pfa.wizard.section-1.description' | transloco"
        ></markant-stepper-item>
        <markant-stepper-item
          [description]="'upgrade.pfa.wizard.section-2.description' | transloco"
        ></markant-stepper-item>
      </markant-stepper-horizontal>
    </section>

    <section class="separator">
      <markant-seperator class="separator-component"></markant-seperator>
    </section>

    @if (upgradeCandidates.length) {
      @switch (currentStepIndex()) {
        @case (0) {
          <markant-platform-upgrade-service-variants
            [form]="variantUpgradeForm"
            [mode]="'edit'"
            [service]="service"
            [booking]="booking()"
            [upgradeCandidates]="upgradeCandidates"
            [organization]="organization()"
            [showErrors]="showUpgradeVariantErrors"
          />
        }
        @case (1) {
          <markant-platform-complete-org-data
            [form]="additionalOrgDataForm"
            [organization]="organization()"
            [showErrors]="showAdditionalOrgaDataErrors"
          />
        }
        @case (2) {
          <markant-platform-variant-upgrade-overview
            [variantUpgradeForm]="variantUpgradeForm"
            [additionalOrgDataForm]="additionalOrgDataForm"
            [upgradeCandidates]="upgradeCandidates"
            [booking]="booking()"
            [organization]="organization()"
          />
        }
      }
    }

    <section
      slot="footer"
      [class.flex-spaced-between]="currentStepIndex() !== 0"
    >
      @if (currentStepIndex() !== 0) {
        <markant-button
          data-cy="upgrade-variant-modal-back-button"
          colorScheme="primary"
          variant="clear"
          (click)="previousStep()"
        >
          <markant-icon icon="m_arrow-left" slot="icon-leading"></markant-icon>
          {{ 'common.back' | transloco }}
        </markant-button>
      }

      <div>
        <markant-button
          data-cy="upgrade-variant-modal-cancel-button"
          colorScheme="primary"
          variant="clear"
          data-markant-dialog-action="cancel"
          (click)="closeDialog.emit()"
        >
          {{ 'common.cancel' | transloco }}
        </markant-button>
        <markant-button
          data-cy="upgrade-variant-modal-next-button"
          colorScheme="primary"
          [loading]="isLoading$ | async"
          (click)="nextStep()"
        >
          {{
            (currentStepIndex() === 2 ? 'general.confirm' : 'common.next')
              | transloco
          }}
        </markant-button>
      </div>
    </section>
  </markant-dialog>
</markant-platform-modal-bridge>
